var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpfulHintIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0FDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3999 17.8913C21.8076 16.4662 19.705 15.5996 17.3999 15.5996C16.348 15.5996 15.3382 15.7801 14.3999 16.1117V30.3617C15.3382 30.0301 16.348 29.8496 17.3999 29.8496C19.705 29.8496 21.8076 30.7162 23.3999 32.1413M23.3999 17.8913C24.9922 16.4662 27.0948 15.5996 29.3999 15.5996C30.4518 15.5996 31.4616 15.7801 32.3999 16.1117V30.3617C31.4616 30.0301 30.4518 29.8496 29.3999 29.8496C27.0948 29.8496 24.9922 30.7162 23.3999 32.1413M23.3999 17.8913V32.1413",
    stroke: "#166534",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpfulHintIcon);
export default __webpack_public_path__ + "static/media/helpful-hint-icon.3823f1383a39dc303247920d9d9c3bd5.svg";
export { ForwardRef as ReactComponent };